"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _translatable = require("./translatable");

Object.keys(_translatable).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _translatable[key];
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./~/react-instantsearch-core/dist/cjs/types/index.js
// module id = 2088
// module chunks = 142807904292071